<div id="searchoption" class="panel-collapse">
	<div class="panel-body">
		<form class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-4 control-label">Infraction</label>
				<div class="col-sm-8 col-md-8 col-lg-6">
					<select class="form-control" name="InfractionID" (ngModelChange)="onInfractionChange($event)" [(ngModel)]="incident.InfractionID">
						<option value="" style="display: none"></option>
						<option *ngFor="let c of infractionList" [ngValue]="c.InfractionID">
							{{ c.InfractionDesc }}
						</option>
					</select>
				</div>
			</div>

			<div class="form-group">
				<label class="col-sm-4 control-label">Action</label>
				<div class="col-sm-8 col-md-8 col-lg-6">
					<select class="form-control" name="PenaltyID" (ngModelChange)="onPenaltyChange($event)" [(ngModel)]="incident.PenaltyID">
						<option value="" style="display: none"></option>
						<option *ngFor="let a of penaltyList" [ngValue]="a.PenaltyID">
							{{ a.PenaltyDesc }}
						</option>
					</select>
				</div>
			</div>
			<!--
      <div class="form-group">
        <label class="col-sm-4  control-label">Alert</label>
        <div class="col-sm-8 col-md-8 col-lg-6">
          <input type="checkbox" ng-model="incident.ContinueAlert" />
        </div>
      </div>

 
      <div *ngIf="showDate">

        <div class="form-group">
          <label class="col-sm-4  control-label">Enter Number of School Days</label>
          <div class="col-sm-8 col-md-8 col-lg-6">
            <input type="checkbox" ng-model="incident.IsUseDayCount" />
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-4  control-label">Start Date</label>
          <div class="col-sm-8 col-md-8 col-lg-6">
            <p-calendar showIcon=true showButtonBar="true" (ngModelChange)="onclassDateChange($event)" [(ngModel)]="incident.StartDate"
              name="txtDate"></p-calendar>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-4  control-label">End Date</label>
          <div class="col-sm-8 col-md-8 col-lg-6">
            <p-calendar *ngIf="!incident.IsUseDayCount" showIcon=true showButtonBar="true" (ngModelChange)="onclassDateChange($event)"
              [(ngModel)]="incident.EndDate" name="txtDate"></p-calendar>
            <p class="form-control-static" *ngIf="incident.IsUseDayCount">{{incident.EndDate}} </p>
          </div>
        </div>

      </div>
    -->

			<div class="form-group">
				<label class="col-sm-4 control-label"></label>
				<div class="col-sm-8 col-md-8 col-lg-6">
					<button type="button" class="btn btn-primary" (click)="onSubmitClick()" href="javascript:void(0);">Submit</button>

					<button type="button" class="btn btn-danger" (click)="cancelClick()" href="javascript:void(0);">Cancel</button>
					<div *ngIf="isSaving" class="alert alert-warning box-msg" role="alert">
						<strong>Submitting Incident. Please wait...</strong>
					</div>
					<div *ngIf="ConfirmSubmitted" class="alert alert-success box-msg" role="alert">
						<strong>Incident Submitted !</strong>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
